<script>
export default {
    props: {
        carTypes: {
            type: Array
        },
        modelValue: {
            type: String
        }
    },
    emits: [
        'update:modelValue'
    ],
    methods: {

        // ...

    },
    mounted() {
        // ...
    }
}
</script>

<template>
    <div class="row">
        <div class="col-lg-4" v-for="carType in carTypes">
            <div class="booking-card booking-card-landscape booking-card-selector" :class="{ 'booking-card-selected': modelValue === carType.name }"
                @click="$emit('update:modelValue', carType.name)">
                <div>
                    <picture>
                        <source :srcset="carType.imageWebp" type="image/webp">
                        <source :srcset="carType.image" type="image/png">
                        <img :src="carType.image" width="200" height="127" class="img-fluid booking-card-image" :alt="$t(carType.properties.displayName)" loading="lazy">
                    </picture>
                </div>
                <div>
                    <div class="booking-card-title text-uppercase">{{ $t(carType.properties.displayName) }}</div>
                    <!--<div class="booking-card-body">&nbsp;</div>-->
                </div>
                <div v-if="carType.description">
                    <i class="fas fa-2x fa-info-circle text-primary" data-bs-toggle="tooltip" :title="$t(carType.description)"></i>
                </div>
            </div>
        </div>

        <div class="col-12">
            <template v-for="carType in carTypes">
                <p class="fs-6" v-if="carType.name == modelValue" v-html="carType.properties.info"></p>
            </template>
        </div>
    </div>
</template>
